<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <GlobalDialog/>
  </div>
</template>

<script>
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import GlobalDialog from '@/components/GlobalDialog.vue'
import { useThemeStore } from '@/stores/themeStore';
import { useLoginStore } from '@/stores/loginStore';

export default {
  components: { GlobalDialog },
  async mounted() {
    // Initialize theme system with user's saved preference
    const themeStore = useThemeStore();
    const loginStore = useLoginStore();
    
    // Load user's theme preference and apply it
    const selectedTheme = loginStore.getSelectedTheme;
    themeStore.loadThemeFromLoginStore(selectedTheme);

    console.log('Running on:', Capacitor.getPlatform());
    if (Capacitor.getPlatform() === 'ios'){
      const root = document.documentElement;
      root.style.setProperty('--header-height', '100px');
      await ScreenOrientation.lock({ orientation: 'portrait' });
      await StatusBar.hide();
      await window.NavigationBar.hide();
    }
    if (Capacitor.getPlatform() === 'android'){
      await ScreenOrientation.lock({ orientation: 'portrait' });
      await StatusBar.hide();
      await window.NavigationBar.hide();
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
//padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* for versions below 2.1.8 */ {
  opacity: 0;
}
</style>
